export const transitionDefinition = "0.2s ease-in-out";
